import type { IBaseAdmin } from "../../BaseAdminFactory";
import type { DeedType } from "le-coffre-resources/dist/Admin";
import type { QueryPayload } from "@Front/Api/types";
import type { IGetDeedTypesParams, IPutDeedTypesParams, IPostDeedTypesParams } from "../DeedTypes";
import {
	buildDeedTypesCreatePayload,
	buildDeedTypesUpdatePayload,
} from "@Front/Api/LeCoffreApi/helpers/businessRequestPayloadHelpers";

export function createGetMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (q: IGetDeedTypesParams): Promise<DeedType[]> => {
		const url = new URL(baseUrl);
		baseAdmin.appendJsonSearchParams(url, { q });
		try {
			return await baseAdmin.getRequest<DeedType[]>(url);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createGetByUidMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (uid: string, q?: QueryPayload): Promise<DeedType> => {
		const url = new URL(baseUrl.concat(`/${uid}`));
		if (q) baseAdmin.appendJsonSearchParams(url, q);
		try {
			return await baseAdmin.getRequest<DeedType>(url);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createPutMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (uid: string, body: IPutDeedTypesParams): Promise<DeedType> => {
		const url = new URL(baseUrl.concat(`/${uid}`));
		try {
			const payload = buildDeedTypesUpdatePayload(body);
			return await baseAdmin.putRequest<DeedType>(url, payload);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createPostMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (body: IPostDeedTypesParams): Promise<DeedType> => {
		const url = new URL(baseUrl);
		try {
			const payload = buildDeedTypesCreatePayload(body);
			return await baseAdmin.postRequest<DeedType>(url, payload);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createDeleteMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (uid: string): Promise<DeedType> => {
		const url = new URL(baseUrl.concat(`/${uid}`));
		try {
			return await baseAdmin.deleteRequest<DeedType>(url);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}
